
export const saasRequest = async (
    tenantUri,
    path,
    webIntegrationId,
    returnJson = true,
) => {
    const res = await fetch(`${tenantUri}${path}`, {
        mode: 'cors',
        credentials: 'include',
        redirect: 'follow',
        headers: {
            'qlik-web-integration-id': webIntegrationId,
        },
    });
    if (res.status < 200 || res.status >= 400) throw res;
    return returnJson ? res.json() : res;
};
